import React, { useEffect, useState } from "react";
import { listSpells, setPendingSpell } from "./SpellManager.js";

export default function SpellMenu({ open, x, y, onClose, spellOrigin, hardcodedMarker, extra = null }) {
  const [spells, setSpells] = useState([]);

  useEffect(() => {
    try {
      const all = listSpells();
      setSpells(Array.isArray(all) ? all : []);
    } catch {
      setSpells([]);
    }
  }, []);

  if (!open) return null;

  const left = Number.isFinite(x) ? x : window.innerWidth / 2;
  const top = Number.isFinite(y) ? y : window.innerHeight / 2;

  function getOriginFromMarker() {
    const m = spellOrigin || hardcodedMarker;
    if (!m) return null;

    const oxRaw = m.x != null ? m.x : m.lng;
    const oyRaw = m.y != null ? m.y : m.lat;

    const ox = Number(oxRaw);
    const oy = Number(oyRaw);

    if (!Number.isFinite(ox) || !Number.isFinite(oy)) return null;
    return { x: ox, y: oy };
  }

  function handleCast(spell) {
    const id = spell.id || spell.name || "";

    const origin = getOriginFromMarker();

    try {
      setPendingSpell(id, {
        origin: origin || null,
        extra: extra && typeof extra === "object" ? { ...extra } : null,
      });
    } catch {}

    if (typeof onClose === "function") onClose();
  }

  function handleOuterClick(e) {
    if (e && typeof e.stopPropagation === "function") e.stopPropagation();
    if (typeof onClose === "function") onClose();
  }

  function handleInnerClick(e) {
    if (e && typeof e.stopPropagation === "function") e.stopPropagation();
  }

  return (
    <div
      onClick={handleOuterClick}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 3000,
        backgroundColor: "transparent",
      }}
    >
      <div
        onClick={handleInnerClick}
        style={{
          position: "fixed",
          left,
          top,
          transform: "translate(-50%, 4px)",
          background: "#23242a",
          borderRadius: 10,
          border: "1px solid #444",
          boxShadow: "0 6px 24px #000c",
          minWidth: 180,
          maxWidth: 260,
          color: "#fff",
          padding: 6,
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
        }}
      >
        <div
          style={{
            padding: "4px 10px 6px",
            fontSize: 13,
            fontWeight: 600,
            opacity: 0.9,
            borderBottom: "1px solid #444",
            marginBottom: 4,
          }}
        >
          Spells
        </div>
        <div
          style={{
            maxHeight: 260,
            overflowY: "auto",
          }}
        >
          {spells.length === 0 && (
            <div
              style={{
                padding: "6px 10px 8px",
                fontSize: 13,
                opacity: 0.7,
              }}
            >
              No spells available.
            </div>
          )}
          {spells.map((spell) => (
            <button
              key={spell.id || spell.name}
              onClick={() => handleCast(spell)}
              style={{
                display: "block",
                width: "100%",
                textAlign: "left",
                padding: "6px 10px",
                margin: "1px 0",
                background: "transparent",
                border: "none",
                color: "#fff",
                fontSize: 13,
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#343542";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              {spell.name || "Spell"}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}